import semver from 'semver';
import { VERSIONS } from './versions';

/**
 * The highest version the docs show in this environment, so upcoming releases can stay hidden. Configured as either
 * the real version or its doc slug, e.g. 4.0.2 or 4.0-beta. Kept apart from versions.ts so build scripts can import
 * that without the Vite-injected global.
 */
function resolveMaxDocsVersion(): string {
  const match = VERSIONS.find((v) => v.value === __MAX_DOCS_VERSION__ || v.docSlug === __MAX_DOCS_VERSION__);
  if (!match) {
    throw new Error(`__MAX_DOCS_VERSION__ "${__MAX_DOCS_VERSION__}" is not a known version or doc slug`);
  }
  return match.value;
}

export const MAX_DOCS_VERSION = resolveMaxDocsVersion();

export const VISIBLE_VERSIONS = VERSIONS.filter((v) => semver.lte(v.value, MAX_DOCS_VERSION));

export function isVisibleVersion(version: string | undefined): version is string {
  return VISIBLE_VERSIONS.some((v) => v.value === version);
}
